import React, { useState, useEffect } from "react";
import { useSupabase } from '../context/SupabaseContext';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// react-bootstrap components
import {
  Badge,
  Button,
  Card,
  Form,
  Navbar,
  Nav,
  Table,
  Container,
  Row,
  Col,
} from "react-bootstrap";

function Wallet() {
  const { transactions, addTransaction, removeTransaction } = useSupabase();
  const [newName, setNewName] = useState("");
  const [newAmount, setNewAmount] = useState("");
  const [newDate, setNewDate] = useState("");

  const fetchData = async () => {
    // Disabled - using Supabase context instead
    console.log('fetchData disabled - using Supabase context');
  };

  useEffect(() => {
    fetchData();
  }, []);

  const newTransaction = async (e) => {
    e.preventDefault();
    
    const transactionData = {
      name: newName,
      amount: parseFloat(newAmount),
      date: newDate,
      category: "General",
      type: 'expense'
    };
    
    try {
      const result = await addTransaction(transactionData);
      if (result.success) {
        // Clear form fields
        setNewName("");
        setNewAmount("");
        setNewDate("");
        toast.success("Transaction added successfully");
      } else {
        toast.error("Failed to add transaction");
      }
    } catch (e) {
      console.error("Error adding transaction:", e);
      toast.error("Failed to add transaction");
    }
  };

  return (
    <>
      <ToastContainer />
      <Container fluid>
        <Row>
          <Col md="12">
            <Card className="strpied-tabled-with-hover">
              <Card.Header>
                <Card.Title as="h4">Manage Wallet</Card.Title>
                <p className="card-category">
                  Add transactions to keep track of your expenses
                </p>
              </Card.Header>
              <Card.Body className="table-full-width table-responsive px-0">
                <Table className="table-hover table-striped">
                  <thead>
                    <tr>
                      <th className="border-0">Serial No.</th>
                      <th className="border-0">Name</th>
                      <th className="border-0">Amount</th>
                      <th className="border-0">Category</th>
                      <th className="border-0">Date</th>
                      <th className="border-0">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {transactions && Array.isArray(transactions) && transactions.map((transaction, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{transaction.name}</td>
                        <td>${transaction.amount}</td>
                        <td>{transaction.category || "General"}</td>
                        <td>{transaction.date}</td>
                        <td>
                          <Button variant="danger" size="sm" onClick={() => {
                            if (window.confirm('Are you sure you want to delete this transaction?')) {
                              removeTransaction(transaction.id);
                            }
                          }}>
                            Delete
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Col>
          <Col md="12">
            <Card>
              <Card.Header>
                <Card.Title as="h4">Add Transaction</Card.Title>
              </Card.Header>
              <Card.Body>
                <Form>
                  <Row>
                    <Col className="pl-4" md="6">
                      <Form.Group>
                        <Form.Label>Name of transaction</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Name of transaction"
                          value={newName}
                          onChange={(e) => setNewName(e.target.value)}
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col className="px-1" md="6">
                      <Form.Group>
                        <Form.Label>Amount</Form.Label>
                        <Form.Control
                          type="number"
                          placeholder="Enter Amount"
                          value={newAmount}
                          onChange={(e) => setNewAmount(e.target.value)}
                          required
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="pl-4" md="6">
                      <Form.Group>
                        <Form.Label>Date</Form.Label>
                        <Form.Control
                          type="date"
                          placeholder="Date"
                          value={newDate}
                          onChange={(e) => setNewDate(e.target.value)}
                          required
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Button className="btn-fill pull-right" variant="success" type="button" onClick={newTransaction}>
                    Add Transaction
                  </Button>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default Wallet;
